// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v5.28.0
// source: plugin/escalated_privilege.proto

/* eslint-disable */

export enum EscalatedPrivilege {
  ALL = 0,
  RELOAD_PLUGIN = 1,
  LOAD_PLUGIN = 2,
  UNLOAD_PLUGIN = 3,
  INSTRUCT_PLUGIN = 4,
  UNRECOGNIZED = -1,
}

export function escalatedPrivilegeFromJSON(object: any): EscalatedPrivilege {
  switch (object) {
    case 0:
    case "ALL":
      return EscalatedPrivilege.ALL;
    case 1:
    case "RELOAD_PLUGIN":
      return EscalatedPrivilege.RELOAD_PLUGIN;
    case 2:
    case "LOAD_PLUGIN":
      return EscalatedPrivilege.LOAD_PLUGIN;
    case 3:
    case "UNLOAD_PLUGIN":
      return EscalatedPrivilege.UNLOAD_PLUGIN;
    case 4:
    case "INSTRUCT_PLUGIN":
      return EscalatedPrivilege.INSTRUCT_PLUGIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EscalatedPrivilege.UNRECOGNIZED;
  }
}

export function escalatedPrivilegeToJSON(object: EscalatedPrivilege): string {
  switch (object) {
    case EscalatedPrivilege.ALL:
      return "ALL";
    case EscalatedPrivilege.RELOAD_PLUGIN:
      return "RELOAD_PLUGIN";
    case EscalatedPrivilege.LOAD_PLUGIN:
      return "LOAD_PLUGIN";
    case EscalatedPrivilege.UNLOAD_PLUGIN:
      return "UNLOAD_PLUGIN";
    case EscalatedPrivilege.INSTRUCT_PLUGIN:
      return "INSTRUCT_PLUGIN";
    case EscalatedPrivilege.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
